import React from 'react';
interface PlaceholderProps {
  children: React.ReactNode;
}
export function Placeholder({
  children
}: PlaceholderProps) {
  return <span title="Placeholder — needs confirmation before publishing" className="rounded border border-dashed border-placeholder-line bg-placeholder px-1 font-medium text-placeholder-ink [box-decoration-break:clone] [-webkit-box-decoration-break:clone]" data-id="element-153" data-mp="3focf6j374g7r">
      [{children}]
    </span>;
}